/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MonitorGetSubmissionSqsMessageDetailsForBrokersGet$Params {
  submissionId?: number;
  schemaName?: string;
}

export function monitorGetSubmissionSqsMessageDetailsForBrokersGet(http: HttpClient, rootUrl: string, params?: MonitorGetSubmissionSqsMessageDetailsForBrokersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, monitorGetSubmissionSqsMessageDetailsForBrokersGet.PATH, 'get');
  if (params) {
    rb.query('submissionId', params.submissionId, {});
    rb.query('schemaName', params.schemaName, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

monitorGetSubmissionSqsMessageDetailsForBrokersGet.PATH = '/Monitor/GetSubmissionSQSMessageDetailsForBrokers';
